import type { DocFolder, RecentFile } from '../types/hr';

export const docFolders: DocFolder[] = [
  { id: 'uploads', name: 'Employee Uploads', count: 6, description: 'Shared by the employee' },
  { id: 'hr', name: 'HR', count: 9, locked: true, description: 'Visible to HR admins only' },
  { id: 'insurance', name: 'Insurance', count: 3, description: 'Benefits & coverage' },
  { id: 'signed', name: 'Signed Documents', count: 7, badge: 'DocuSign', description: 'Completed e-signatures' },
  { id: 'onboarding', name: 'Onboarding', count: 5, description: 'Offer, I-9, W-4 & setup' },
];

export const recentFiles: RecentFile[] = [
  { id: 'f1', name: 'Offer Letter – Signed.pdf', folder: 'Signed Documents', size: '184 KB', date: '2026-10-28', by: 'DocuSign' },
  { id: 'f2', name: 'W-4 2026 (Demo).pdf', folder: 'HR', size: '96 KB', date: '2026-10-21', by: 'Jordan Avery' },
  { id: 'f3', name: 'Benefits Enrollment Confirmation.pdf', folder: 'Insurance', size: '212 KB', date: '2026-10-15', by: 'Jordan Avery' },
  { id: 'f4', name: 'NMLS License Copy (Demo).pdf', folder: 'Employee Uploads', size: '1.2 MB', date: '2026-09-30', by: 'Employee' },
  { id: 'f5', name: 'Direct Deposit Form.pdf', folder: 'Onboarding', size: '74 KB', date: '2026-09-12', by: 'Employee' },
  { id: 'f6', name: 'Handbook Acknowledgment.pdf', folder: 'Signed Documents', size: '128 KB', date: '2026-08-04', by: 'DocuSign' },
];
